import {Injectable,} from '@angular/core';

Date.prototype.toJSON = function(): string {
  // ISO8601拡張形式＋ミリ秒で返す
  return this.toISOString();
}

/**
 * JSON変換サービス.
 */
@Injectable({
  providedIn: 'root',
})
export class JsonUtil {
  /**
   * [一般開発者利用可]
   * JSON形式含むオブジェクトを文字列化する
   * @param value JSON形式含むオブジェクト
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any,@typescript-eslint/explicit-module-boundary-types
  stringify(value: any): string {
    return JSON.stringify(value);
  }

  /**
   * [一般開発者利用可]
   * 文字列をオブジェクトに変換する
   * @param value オブジェクト化するための文字列
   */
  parse<T>(value: string): T {
    return JSON.parse(value, this.dateReviver.bind(this));
  }

  /**
   * [一般開発者利用可]
   * 文字列にシリアライズされたDate文字列が含まれていたらDate型に変換する
   * @param value オブジェクト
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any,@typescript-eslint/explicit-module-boundary-types
  dateReviver(key: string, value: any): any {
    if (this.isSerializedDate(value)) {
        return(new Date(value));
    }
    return( value );
  }

  /**
   * [一般開発者利用可]
   * シリアライズされたDate文字列が含まれているか判定する
   * @param value 判定したい文字列
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any,@typescript-eslint/explicit-module-boundary-types
  isSerializedDate(value: any): boolean {
      const datePattern = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{3}Z$/;
      return({}.toString.call(value) === '[object String]' && datePattern.test(value));
  }
}
